module.exports = __webpack_public_path__ + "static/media/tom.446e78dd.wav";